module.exports = __webpack_public_path__ + "0076cf321da878254c87b23535d79913.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/UAlogo.png
// module id = 396
// module chunks = 0